/**
 * Plan 454 M5 (task:target-unresolved-state). Copy + destination for the
 * "your target has no resolved ZIP" state, shared by every surface that
 * renders it (Browse, `/offers` via `TargetConfirmLine`, and Home's
 * `no_target` hero via `deriveHomeHeroState`) so they cannot drift.
 */

/** The target-area row on the Passport (`profile-row-${rowId}` in the profile
 *  row shell) - the same destination Home's `no_target` hero already used. */
export const TARGET_CONFIRM_HREF =
  "/dashboard?view=passport#profile-row-target_area";

export const TARGET_CONFIRM_LINE =
  "Confirm your target city or ZIP to see agents.";

export const TARGET_CONFIRM_LINK_LABEL = "Confirm target";
